import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { environmentIa } from 'src/environments/environment.ia';

@Injectable({
  providedIn: 'root'
})
export class ComproCabeProveIaService {

  private apiUrlIa = environmentIa.production ? environmentIa.apiUrlProd : environmentIa.apiUrl;

  constructor( private http: HttpClient, private authService: AuthService ) { }

  postComproCabeProve(archivo: File, modoCarga: string, cenco: string): Observable<any> {
    const formData = new FormData();
    formData.append('file', archivo, archivo.name);
    formData.append('modoCarga', modoCarga);
    formData.append('cenco', cenco);

    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.authService.getToken()}`);
    return this.http.post(`${this.apiUrlIa}/compro-cabe-prove-ia/importar`, formData, { headers });
}
}
